'use client';

import React from 'react';
// Client-only: the player reads the <audio> element and Web Audio APIs directly
import dynamic from 'next/dynamic';
import { css } from 'styled-system/css';

const AudioPlayer = dynamic(() => import('./AudioPlayer'), {
  ssr: false,
});

export default function AudioPlayerPage() {
  return (
    <div
      className={css({
        mx: 'auto',
        maxW: '360px',
        minH: '500px',
        borderRadius: '3xl',
        boxShadow: '2xl',
        my: '6',
        p: '6',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        position: 'relative',
      })}
    >
      <h4 className={css({ textAlign: 'center' })}>曾经的你</h4>
      <AudioPlayer src='/media/you.mp3' paidPercentage={0.6} />
    </div>
  );
}
